import React from "react";

const CameraRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  x: 2.55,
  y: 4.55,
  width: 10.9,
  height: 10.9,
  rx: 1.45,
  stroke: "currentColor",
  strokeWidth: 1.1
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_379_558",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 7.6L17.4855 4.9087C18.152 4.50878 19 4.9889 19 5.76619V14.2338C19 15.0111 18.152 15.4912 17.4855 15.0913L13 12.4V7.6Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M13 7.6L12.4341 6.65676L11.9 6.97719V7.6H13ZM13 12.4H11.9V13.0228L12.4341 13.3432L13 12.4ZM13.5659 8.54324L18.0515 5.85194L16.9196 3.96545L12.4341 6.65676L13.5659 8.54324ZM17.9 5.76619V14.2338H20.1V5.76619H17.9ZM18.0515 14.1481L13.5659 11.4568L12.4341 13.3432L16.9196 16.0345L18.0515 14.1481ZM14.1 12.4V7.6H11.9V12.4H14.1ZM17.9 14.2338C17.9 14.2233 17.9041 14.202 17.9169 14.181C17.9278 14.163 17.9404 14.1526 17.9507 14.1468C17.9611 14.1409 17.9764 14.1355 17.9975 14.1354C18.0221 14.1352 18.0424 14.1426 18.0515 14.1481L16.9196 16.0345C18.3193 16.8744 20.1 15.8661 20.1 14.2338H17.9ZM18.0515 5.85194C18.0424 5.85736 18.0221 5.86477 17.9975 5.86464C17.9764 5.86453 17.9611 5.85906 17.9507 5.85321C17.9404 5.84736 17.9278 5.837 17.9169 5.81898C17.9041 5.79797 17.9 5.77672 17.9 5.76619H20.1C20.1 4.13387 18.3193 3.12563 16.9196 3.96545L18.0515 5.85194Z",
  fill: "currentColor",
  mask: "url(#path-2-inside-1_379_558)"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CameraRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;